/**
 * Walks the happy-flow chain from startId via successNext, in order. This is
 * the authoritative step order — array order from the API is never
 * guaranteed (no ORDER BY, and Postgres doesn't promise row order on a plain
 * SELECT), so it must never drive display order, "what's the last step", or
 * previous/next navigation.
 */
export function walkStepChain<T extends { id: string; successNext: string | null }>(
  steps: T[],
  startId: string | null,
): T[] {
  const byId = new Map(steps.map((s) => [s.id, s]));
  const order: T[] = [];
  let cursor = startId;
  const seen = new Set<string>();
  while (cursor && !seen.has(cursor)) {
    seen.add(cursor);
    const step = byId.get(cursor);
    if (!step) break;
    order.push(step);
    cursor = step.successNext;
  }
  return order;
}

export function findChainTail<T extends { id: string; successNext: string | null }>(
  steps: T[],
  startId: string | null,
): T | null {
  return walkStepChain(steps, startId).at(-1) ?? null;
}
